import React from "react";
import ReactTooltip from "react-tooltip";
import "./index.scss";

export const Tooltip = () => (
  <ReactTooltip className="tooltip" type="light" effect="solid" />
);
